<div fxLayout="row">
    <div fxLayout="column" class="donut" [class.days-1]="days === 1" [class.days-2]="days === 2" [class.days-3]="days === 3" [class.days-4]="days === 4" [class.days-5]="days === 5" [class.days-6]="days === 6" [class.days-7]="days === 7" id={{donutcurrentId}} fxFlex="100" (resized)="onResized($event)">
    </div>
    <div fxLayout="column" class="legend legend-group" id={{legendcurrentId}}></div>
</div>